import { Sun, Timer, TrendingUp, ThermometerSnowflake } from "lucide-react";
import { useProduct, promoEndLabel, eur } from "@/lib/product";
import { SectionHead } from "./SectionHead";

export const Urgency = () => {
  const { product } = useProduct();
  const active = product?.promo_active;
  const cards = [
    {
      id: "heatwave",
      icon: Sun,
      tag: "Climat",
      title: "Après l'été 2026, préparez 2027",
      body: "L'été 2026 a été marqué par des épisodes de canicule intenses et répétés. Les prévisions climatiques annoncent des étés de plus en plus chauds, et l'été 2027 pourrait l'être encore davantage. S'équiper maintenant, c'est être prêt dès les premières chaleurs.",
    },
    {
      id: "stock",
      icon: Timer,
      tag: "Déstockage",
      title: active ? "Un tarif limité dans le temps" : "Disponibilité saisonnière",
      body: active
        ? `Ce prix correspond à une opération de déstockage ponctuelle, valable jusqu'au ${promoEndLabel(product.promo_end)} (heure de Paris). Passé cette date, l'appareil sera vendu ${eur(product.normal_price)}, son prix public conseillé.`
        : "Les stocks de climatiseurs se renouvellent par lots. Commander hors saison vous garantit de l'avoir avant les premières chaleurs.",
    },
    {
      id: "rush",
      icon: TrendingUp,
      tag: "Anticipation",
      title: "Avant la ruée du printemps",
      body: "Chaque année, dès les premières vagues de chaleur, la demande de climatiseurs s'envole et les ruptures de stock se multiplient. Commander hors saison, c'est éviter l'attente au moment où vous en aurez le plus besoin.",
    },
    {
      id: "heating",
      icon: ThermometerSnowflake,
      tag: "Cet hiver",
      title: "Il vous chauffe aussi dès maintenant",
      body: "Sa pompe à chaleur (classe A+, SCOP 4,0) restitue en moyenne environ 4 kWh de chaleur pour 1 kWh d'électricité consommé sur la saison. Un chauffage d'appoint économique, utile dès cet hiver.",
    },
  ];

  return (
    <section id="pourquoi" data-testid="urgency-section" className="section bg-white">
      <div className="container-x">
        <SectionHead eyebrow="Pourquoi commander maintenant" title="Le bon moment pour s'équiper, c'est avant l'été." heat />
        <div className="grid md:grid-cols-2 gap-5 mt-12">
          {cards.map(({ id, icon: Icon, tag, title, body }, i) => (
            <article key={id} data-testid={`urgency-card-${id}`} className={`urgency-card ${i === 0 ? "md:row-span-1" : ""}`}>
              <div className="flex items-center gap-3">
                <span className="icon-heat"><Icon className="w-5 h-5" /></span>
                <span className="text-xs font-bold uppercase tracking-[0.18em] text-orange-600">{tag}</span>
              </div>
              <h3 className="font-display text-xl sm:text-2xl font-bold tracking-tight text-slate-900 mt-5">{title}</h3>
              <p className="text-slate-600 leading-relaxed mt-3">{body}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};
